import { render, staticRenderFns } from "./SupliersCreditors.vue?vue&type=template&id=355b2fbe&"
import script from "./SupliersCreditors.vue?vue&type=script&lang=js&"
export * from "./SupliersCreditors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports